// extracted by mini-css-extract-plugin
export default {"header":"U1FKpy5JG_33nJZy0TSs","logo":"BXRQ6XoW_I6NdA_SdgD0","title":"G7cmgYePlQy4dov_UJjI"};